import { TToggleBannerParams } from 'core/model/interfaces/banners';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { getErrorMessageFromAction } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import { IBannersState } from '../types';

export const toggleBanner = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/toggleBanner`,
  async (params: { data: TToggleBannerParams }, { rejectWithValue }) => {
    try {
      const { data } = params;

      await apiService.banners.toggleBanner(data);

      notificationService.global.success(`Banner ${data.isActive ? 'activado' : 'desactivado'} correctamente.`);
    } catch (error) {
      notificationService.global.error('Error al cambiar el estado del banner.');

      return rejectWithValue(error);
    }
  },
);

export const toggleBannerReducer: TSliceExtraReducer<IBannersState> = builder =>
  builder
    .addCase(toggleBanner.pending, state => {
      state.modal.loading = true;
      state.modal.success = false;
    })
    .addCase(toggleBanner.rejected, (state, action) => {
      state.modal.loading = false;
      state.modal.success = false;

      state.modal.error = getErrorMessageFromAction(action.payload, 'Error al cambiar el estado del banner.');
    })
    .addCase(toggleBanner.fulfilled, state => {
      state.modal.loading = false;
      state.modal.success = true;
    });
